import { Link as RouterLink, matchPath, useLocation } from "react-router-dom";

export default function NavSectionItem({ data }) {
  const { pathname } = useLocation();
  const Icon = data.icon;

  const active = data.exact
    ? pathname === data.path
    : Boolean(
        data.path && matchPath({ path: data.path, end: false }, pathname)
      );

  const className = `sidebar-nav-item${active ? " is-active" : ""}`;

  return (
    <RouterLink
      to={data.path}
      className={className}
      aria-current={active ? "page" : undefined}
    >
      <span className="sidebar-nav-item__icon">
        {Icon ? <Icon size={20} strokeWidth={2} aria-hidden="true" /> : null}
      </span>
      <span className="sidebar-nav-item__label">{data.title}</span>
      {active ? (
        <span className="sidebar-nav-item__indicator" aria-hidden="true" />
      ) : null}
    </RouterLink>
  );
}
